module.exports = __webpack_public_path__ + "assets/572fd030a1d216e885427f39b9f0dabf.mp3";